/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const EPISODIC_ASSET_WIDTH = 382;
export const MOVIE_ASSET_WIDTH = 196;

export const CELLS_TO_HAVE_AHEAD = 8;
export const CELLS_TO_HAVE_BEHIND = 4;

export const DESCRIPTION_CONTAINER_HEIGHT = 144;
